/**
 * An API error that a request expects, by its `error.locale.key`. The HTTP
 * client raises it instead of the global error alert, so the caller can react
 * to it, for example by showing the localized message next to a form.
 */
export class HExpectedApiError extends Error {
  readonly key: string;

  constructor(key: string, message?: string) {
    super(message || key);
    this.name = 'HExpectedApiError';
    this.key = key;
  }
}

export function isExpectedApiError(error: unknown): error is HExpectedApiError {
  return error instanceof Error && error.name === 'HExpectedApiError' && typeof (error as HExpectedApiError).key === 'string';
}

/** The localization key of an Onify API error body: `{ error: { locale: { key } } }`. */
export function apiErrorKey(body: unknown): string | undefined {
  const key = (body as { error?: { locale?: { key?: unknown } } } | null | undefined)?.error?.locale?.key;
  return typeof key === 'string' ? key : undefined;
}
